module.exports = __webpack_public_path__ + "static/img/same-brands-01.fe9e51f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/same-brands-01.jpg
// module id = 289
// module chunks = 1